import { ExamplePromptData, ExamplePromptCategory } from '../components/ExamplePrompt';

/**
 * get example conversation prompts to display from list of example prompts
 */
const pickRandomString = (prompts: string[]) => {
  if (!prompts.length) throw new Error(`Empty prompts`);
  return prompts[Math.floor(Math.random() * prompts.length)];
};
type ExamplePromptsTranslatedValue = string;

const orderedExamplePromptCategories = [
  ExamplePromptCategory.Build,
  ExamplePromptCategory.Grow,
  ExamplePromptCategory.Monetize,
];

const translatedPromptsByCategoryListConcatenationDelimiter = '|';

// in case of invalid format, provide fallbacks guaranteed to be in valid format
const translatedPromptsByCategoryFallbacks = {
  [ExamplePromptCategory.Build]: `Can you explain a script to me? Reply and I'll share it.|Can you help fix a script? Reply and I'll share my script and what I'm trying to do.|How do I create an avatar item? Reply and I'll share details.|Can you help me design a fun core loop that brings player back to my game? Reply and I'll share more.|How do I build a new Roblox experience from scratch?|How do I add background music to my experience?|Can you explain step by step how I can learn scripting?|Why should I build on Roblox?|What is streaming and how will it help my experience?|How can I use Toolbox to add assets and characters to my experience?|What tools can help me track my experience's performance and errors in real time?|Can you help me brainstorm ideas for a new experience? Reply and I'll share more.|How do I animate a character? Reply and I'll share more.|I'm building a new experience. Can you help? Reply and I'll share more.`,
  [ExamplePromptCategory.Grow]: `How do I get new users to come back to my experience? Reply and I'll share details.|Can you give me advice on designing a progression system? Reply and I'll share details.|How do I use insights to figure out how to grow my experience?|How does the Roblox algorithm work and how can I use it to help people find my experience?|I'm launching a new experience. What are some best practices for launch?|How do I get new players to stay longer? Reply and I'll share details.|How can I use sponsored ads to grow my experience?|How do I know what demographics are playing my experience?|How do I bring new users to my experience? Reply and I'll share what I'm doing so far.|How do I use player invite prompts to grow my experience?|How can I grow sales for my avatar items?|What external channels can I use to grow my experience?|Can you give me a pep talk and tips on how to improve my experience? Reply and I'll share more.`,
  [ExamplePromptCategory.Monetize]: `What options do I have to monetize my experience?|What is Game Pass and how do I set it up?|How do I get players to purchase dev products in my experience?|What are tips for setting up a shop in my experience to sell items? Reply and I'll share more.|What items should I sell in my shop? Reply and I'll share more.|How do I increase payer conversion rate? Reply and I'll share more.|What are tips for balancing my virtual economy? Reply and I'll share more.|Can you help me add a season pass to my experience? Reply and I"ll share more.|How do Limited avatar items work and what are some tips to sell them?`,
};

const getShuffledExamplePrompts = (
  translatedPromptsByCategory: Record<ExamplePromptCategory, ExamplePromptsTranslatedValue>,
  translatedHeaderByCategory: Record<ExamplePromptCategory, string>,
): ExamplePromptData[] => {
  return orderedExamplePromptCategories.map((category: ExamplePromptCategory) => {
    let prompt: string;
    try {
      prompt = pickRandomString(
        translatedPromptsByCategory[category].split(
          translatedPromptsByCategoryListConcatenationDelimiter,
        ),
      );
    } catch {
      prompt = pickRandomString(
        translatedPromptsByCategoryFallbacks[category].split(
          translatedPromptsByCategoryListConcatenationDelimiter,
        ),
      );
    }
    return {
      category,
      header: translatedHeaderByCategory[category],
      prompt,
    };
  });
};

export default getShuffledExamplePrompts;
